import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';

export const DASHBOARD_TITLES: [RegExp, string][] = [
  [/^\/$/, 'Dashboard'],
  [/^\/orders\/scan/, 'Scan pickup code'],
  [/^\/orders\/./, 'Order'],
  [/^\/orders/, 'Orders'],
  [/^\/inventory\/receive/, 'Receive stock'],
  [/^\/inventory\/history/, 'Stock history'],
  [/^\/inventory\/bulk/, 'Bulk tools'],
  [/^\/inventory/, 'Inventory'],
  [/^\/products\/categories/, 'Categories'],
  [/^\/products\/library/, 'Product library'],
  [/^\/products\/./, 'Product'],
  [/^\/products/, 'Products'],
  [/^\/promotions/, 'Deals & specials'],
  [/^\/coupons/, 'Coupons'],
  [/^\/customers/, 'Customers'],
  [/^\/reports/, 'Reports'],
  [/^\/audit/, 'Audit log'],
  [/^\/store/, 'Store info'],
  [/^\/staff/, 'Staff'],
  [/^\/settings/, 'Settings'],
];

/**
 * Single-page-app accessibility: each route gets a document title, and after client-side navigation focus
 * moves to the main region and the new page is announced, as a full page load would for screen readers.
 * Pages with dynamic names (products) set their own title, which wins.
 */
export function RouteA11y({ appName, titles, mainId = 'main' }: { appName: string; titles: [RegExp, string][]; mainId?: string }) {
  const { pathname } = useLocation();
  const first = useRef(true);
  const [announcement, setAnnouncement] = useState('');

  useEffect(() => {
    const title = titles.find(([re]) => re.test(pathname))?.[1];
    if (title) document.title = `${title} · ${appName}`;
    if (first.current) {
      first.current = false;
      return;
    }
    const main = document.getElementById(mainId);
    main?.focus({ preventScroll: true });
    window.scrollTo(0, 0);
    // Let pages set their own title first (e.g. product name), then announce it.
    const t = setTimeout(() => setAnnouncement(document.title.replace(` · ${appName}`, '')), 150);
    return () => clearTimeout(t);
  }, [pathname, appName, mainId, titles]);

  return (
    <p className="sd-visually-hidden" aria-live="polite" aria-atomic="true">
      {announcement}
    </p>
  );
}
